import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Save, MessagesSquare } from "lucide-react";

export default function AdminCategories() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [savingSlug, setSavingSlug] = useState("");

  const load = async () => {
    setLoading(true);
    const { data } = await api.get("/categories");
    setItems(data);
    setLoading(false);
  };

  useEffect(() => {
    load();
  }, []);

  const update = (slug, field, value) => {
    setItems((prev) => prev.map((c) => (c.slug === slug ? { ...c, [field]: value } : c)));
  };

  const save = async (cat) => {
    setSavingSlug(cat.slug);
    try {
      await api.patch(`/categories/${cat.slug}`, {
        name: cat.name,
        description: cat.description,
      });
      toast.success("Kategori güncellendi");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Güncellenemedi");
    } finally {
      setSavingSlug("");
    }
  };

  return (
    <div className="k-container py-12 md:py-16">
      <div className="flex items-center gap-3">
        <span className="grid h-12 w-12 place-items-center rounded-2xl bg-earth-400/20 text-earth-500">
          <MessagesSquare className="h-6 w-6" />
        </span>
        <div>
          <h1 className="font-display text-5xl text-ink-900" data-testid="admin-categories-title">
            Tartışma kategorileri
          </h1>
          <p className="font-body text-ink-700">
            İsim ve açıklamayı düzenleyebilirsin. Bağlantı adresi (slug) sabit kalır — mevcut konular korunur.
          </p>
        </div>
      </div>

      <div className="mt-10 space-y-4">
        {loading && [1, 2, 3, 4].map((i) => <div key={i} className="k-card h-48 animate-pulse" />)}
        {!loading &&
          items.map((c) => (
            <div key={c.slug} className="k-card p-6" data-testid={`admin-cat-${c.slug}`}>
              <div className="flex flex-wrap items-center justify-between gap-2 text-xs text-ink-500">
                <span className="font-mono">/{c.slug}</span>
                <span>{c.topic_count} konu</span>
              </div>
              <div className="mt-4 space-y-4">
                <div>
                  <label className="k-label">İsim</label>
                  <input
                    className="k-input"
                    value={c.name}
                    onChange={(e) => update(c.slug, "name", e.target.value)}
                    data-testid={`admin-cat-name-${c.slug}`}
                  />
                </div>
                <div>
                  <label className="k-label">Açıklama</label>
                  <textarea
                    rows={2}
                    className="k-input resize-none"
                    value={c.description}
                    onChange={(e) => update(c.slug, "description", e.target.value)}
                    data-testid={`admin-cat-desc-${c.slug}`}
                  />
                </div>
                <button
                  onClick={() => save(c)}
                  disabled={savingSlug === c.slug}
                  className="k-btn-primary text-sm py-2 disabled:opacity-60"
                  data-testid={`admin-cat-save-${c.slug}`}
                >
                  <Save className="mr-2 h-4 w-4" />
                  {savingSlug === c.slug ? "Kaydediliyor…" : "Kaydet"}
                </button>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}
